import React from "react";
import {
  Button,
  TextField,
} from "@mui/material";

interface ConversationLogFormProps {
  notes: string;

  onChange: {
    setNotes: (value: string) => void;
  };

  onSubmit: (
    event: React.FormEvent<HTMLFormElement>
  ) => void;
}

export default function ConversationLogForm({
  notes,
  onChange,
  onSubmit,
}: ConversationLogFormProps) {
  return (
    <form onSubmit={onSubmit}>
      <TextField
        label="Notes"
        value={notes}
        onChange={(event) =>
          onChange.setNotes(event.target.value)
        }
        fullWidth
        multiline
        minRows={4}
        maxRows={10}
        autoComplete="off"
        sx={{
          mt: 1,
        }}
      />

      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{
          mt: 2,
          minHeight: 46,
        }}
      >
        Save Conversation Note
      </Button>
    </form>
  );
}